import PropTypes from 'prop-types';
import React from 'react';

function EmailWidget(props) {
  const { BaseInput } = props.registry.widgets;
  return <BaseInput type="email" {...props} />;
}

EmailWidget.propTypes = {
  value: PropTypes.string,
};

export default EmailWidget;
